// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"78":"592e6685","227":"5a160642"}[chunkId] + ".chunk.css";
};